import { useMsal } from "@azure/msal-react";
import { type AccountInfo } from "@azure/msal-browser";

export function useProfile(): AccountInfo | null {
  const { accounts } = useMsal();
  return accounts.length > 0 ? accounts[0] : null;
}
